import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import sfgif from "../Images/sfgif.gif";
import sf1 from "../Images/sf1.jpg";
import { project_name } from "../Config/config";

export default function SalesForecasting() {
  return (
    <>
      {/* <!-- Required meta tags --> */}
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="description"
        content="Sales forecasting predicts what your sales pipeline may look like in the future. By using an INDSAC-CRM with sales forecast services, sales teams can fine-tune their selling strategy"
      />
      <meta property="og:title" content="Sales Forecasting" />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://entelipro.com/salesforecasting"
      />
      <meta
        property="og:image"
        content="https://www.entelipro.com/static/media/sfgif.gif"
      />
      <meta
        property="og:image:secure_url"
        content="https://www.entelipro.com/static/media/sfgif.gif"
      />
      <meta property="og:site_name" content="entelipro.com" />
      <meta
        property="og:description"
        content="Sales forecasting predicts what your sales pipeline may look like in the future. By using an INDSAC-CRM with sales forecast services, sales teams can fine-tune their selling strategy"
      />
      <meta property="og:locale" content="en_US" />

      <script type="application/ld+json">
        `
        {`"@context":"https://schema.org","@type":"WebPage","name":"Sales Forecasting",
        "logo":{"@type":"ImageObject","url":"https://www.entelipro.com/web/dist/img/u.png"},"url":"https://entelipro.com/salesforecasting"`}
        `
      </script>

      <title>
        Sales Forecasting | Best CRM Software | Indsac Crm :: entelipro.com
      </title>
      <Navbar />

      {/* <!-- breadcrumbs --> */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/services">
                  Services{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Sales Forecasting</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- breadcrumbs //--> */}
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="main-titles-head text-center">
              <h3 className="header-name">Sales Forecasting</h3>
            </div>
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img src={sfgif} alt="product" className="img-responsive " />
              </div>
              <div className="cwp4-text col-xl-6">
                <p className="para">
                  {" "}
                  Sales forecasting predicts what your sales pipeline may look
                  like in the future.{" "}
                </p>
                <br />
                <p className="para">
                  {" "}
                  By using an {`${project_name}`} with sales forecast services,
                  sales teams can fine-tune their selling strategy.{" "}
                </p>
                <br />
                <p className="para">
                  Sales reps can see how they're tracking against their quotas
                  at any given moment, while sales managers can make more
                  informed business decisions on how to manage their resources.
                </p>
                <br />
                <p className="para">
                  {" "}
                  Then, you can eventually use it to shape your forecast. <br />
                  When you do, you may notice the accuracy of your predictions
                  goes up.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="container">
              <div className="cwp4-two row">
                <div className="cwp4-text col-xl-6">
                  <h4>The Importance of Sales Forecasting</h4>
                  <p className="para">
                    {" "}
                    1. Map out Sales Growth
                    <br />
                    <br />
                    2. Ensure You Have the Right Resources
                    <br />
                    <br />
                    3. Plan Your Sales Budget <br />
                    <br />
                    4. Anticipate Revenue <br />
                    <br />
                    5. Predict Product Interest
                    <br />
                    <br />
                    6. Attract Investors <br />
                    <br />
                    7. Boost Stock Market Prices <br />
                    <br />
                  </p>
                </div>
                <div className="col-xl-6 cwp4-image ">
                  <img src={sf1} alt="product" className="img-responsive " />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-features-4">
        <div className="features4-block">
          <div className="container">
            <div className="main-titles-head text-center">
              <h3 className="header-name">
                Accurate forecasting is a core requirement for any successful
                sales strategy.
              </h3>
            </div>
            <div className="features-effect row text-center">
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <p className="para">
                    {" "}
                    Wide range of reporting tools to analyze your sales
                    performance compared to previous periods, track and improve
                    team productivity.
                  </p>
                </div>
              </div>

              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <p className="para">
                    sales reps can prioritize the prospects that are ready to
                    buy and identify the leads that need further nurturing from
                    the marketing department.
                  </p>
                </div>
              </div>

              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <p className="para">
                    Identify top lead sources and allocate resources toward your
                    most profitable sales activities.
                  </p>
                </div>
              </div>

              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1">
                <div className="back-color">
                  <p className="para">
                    {" "}
                    Generate sales forecast reports on-demand to see projected
                    sales and get valuable insights on your team's sales to
                    date, current deals in the pipeline, and quota.
                  </p>
                </div>
              </div>

              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1">
                <div className="back-color">
                  <p className="para">
                    When the strength of your sales team fluctuates, your sales
                    numbers will automatically change. When you hire more sales
                    reps, the sales prediction increases considerably.{" "}
                  </p>
                </div>
              </div>

              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1">
                <div className="back-color">
                  <p className="para">
                    Sales reps require time to adjust to a new territory. Sales
                    are usually better in familiar territories than in new
                    territory when a rep is just settling in.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
